import { isWithinInterval } from 'date-fns';
import { dayStatus } from '../../constants';

export function isNotAvailableDay(day) {
    return (
        day?.status === dayStatus.SOLD_OUT ||
        day?.status === dayStatus.NOT_AVAILABLE ||
        day?.status === dayStatus.STOP_SALE ||
        day?.isEnabled === false
    );
}

export function getDaysOfMonth(monthNo, year, calendar) {
    if (!calendar) {
        return [];
    }

    for (let i = 0; i < calendar?.length; i++) {
        const month = calendar[i];

        if (month?.fd_Month === monthNo && month?.fd_Year === year) {
            return month?.fd_JsonResult?.data?.days;
        }
    }

    return [];
}

export function calcTotalBookingValue(checkInDay, checkOutDay, calendar) {
    let totalBookingValue = 0;

    if (!checkOutDay) {
        return checkInDay?.price ?? 0;
    }

    // Get all days
    const checkInMonthNo = new Date(checkInDay?.date).getMonth() + 1;
    const checkOutMonthNo = new Date(checkOutDay?.date).getMonth() + 1;
    const checkInDayDateObj = new Date(checkInDay?.date);
    const checkInYear = checkInDayDateObj.getFullYear();

    const checkOutDayDateObj = new Date(checkOutDay?.date);
    const checkOutYear = checkOutDayDateObj.getFullYear();

    const checkInMonthDays = getDaysOfMonth(
        checkInMonthNo,
        checkInYear,
        calendar
    );

    let checkOutMonthDays = [];
    if (checkInMonthNo !== checkOutMonthNo) {
        checkOutMonthDays = getDaysOfMonth(
            checkOutMonthNo,
            checkOutYear,
            calendar
        );
    }
    const allDays = [...checkInMonthDays, ...checkOutMonthDays];

    const daysBetweenCheckInAndCheckOut = allDays.filter((_day) => {
        const isDayWithinInterval = isWithinInterval(new Date(_day?.date), {
            start: new Date(checkInDay?.date),
            end: new Date(checkOutDay?.date),
        });

        return isDayWithinInterval;
    });

    // remove last value from the array
    // don't calculate last day price that's the day you're leaving
    daysBetweenCheckInAndCheckOut.pop();

    totalBookingValue = daysBetweenCheckInAndCheckOut.reduce(
        (previousValue, day) => previousValue + day?.price ?? 0,
        0
    );

    return totalBookingValue;
}
